/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	DepartmentDTO,
	DepartmentDTOFromJSON,
	DepartmentDTOFromJSONTyped,
	DepartmentDTOToJSON,
} from "./DepartmentDTO";
import {
	EmailPriority,
	EmailPriorityFromJSON,
	EmailPriorityFromJSONTyped,
	EmailPriorityToJSON,
} from "./EmailPriority";
import {
	EmailRecipientDTO,
	EmailRecipientDTOFromJSON,
	EmailRecipientDTOFromJSONTyped,
	EmailRecipientDTOToJSON,
} from "./EmailRecipientDTO";
import {
	EmailSendStrategy,
	EmailSendStrategyFromJSON,
	EmailSendStrategyFromJSONTyped,
	EmailSendStrategyToJSON,
} from "./EmailSendStrategy";
import {
	FacultyDTO,
	FacultyDTOFromJSON,
	FacultyDTOFromJSONTyped,
	FacultyDTOToJSON,
} from "./FacultyDTO";
import { Role, RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from "./Role";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";
import {
	StudyProgramDTO,
	StudyProgramDTOFromJSON,
	StudyProgramDTOFromJSONTyped,
	StudyProgramDTOToJSON,
} from "./StudyProgramDTO";

/**
 *
 * @export
 * @interface NewsletterEmailDTO
 */
export interface NewsletterEmailDTO {
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmailDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmailDTO
	 */
	subject?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmailDTO
	 */
	body?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmailDTO
	 */
	newsletterChannel?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof NewsletterEmailDTO
	 */
	publisherName?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof NewsletterEmailDTO
	 */
	initialRecipientsCount?: number;
	/**
	 *
	 * @type {number}
	 * @memberof NewsletterEmailDTO
	 */
	currentRecipientsCount?: number;
	/**
	 *
	 * @type {EmailPriority}
	 * @memberof NewsletterEmailDTO
	 */
	priority?: EmailPriority;
	/**
	 *
	 * @type {boolean}
	 * @memberof NewsletterEmailDTO
	 */
	expeditionEnabled?: boolean;
	/**
	 *
	 * @type {Array<EmailRecipientDTO>}
	 * @memberof NewsletterEmailDTO
	 */
	recipients?: Array<EmailRecipientDTO> | null;
	/**
	 *
	 * @type {EmailSendStrategy}
	 * @memberof NewsletterEmailDTO
	 */
	strategy?: EmailSendStrategy;
	/**
	 *
	 * @type {Role}
	 * @memberof NewsletterEmailDTO
	 */
	recipientRole?: Role;
	/**
	 *
	 * @type {Array<StudentYearEnum>}
	 * @memberof NewsletterEmailDTO
	 */
	years?: Array<StudentYearEnum> | null;
	/**
	 *
	 * @type {Array<FacultyDTO>}
	 * @memberof NewsletterEmailDTO
	 */
	faculties?: Array<FacultyDTO> | null;
	/**
	 *
	 * @type {Array<DepartmentDTO>}
	 * @memberof NewsletterEmailDTO
	 */
	departments?: Array<DepartmentDTO> | null;
	/**
	 *
	 * @type {Array<StudyProgramDTO>}
	 * @memberof NewsletterEmailDTO
	 */
	studyPrograms?: Array<StudyProgramDTO> | null;
}

export function NewsletterEmailDTOFromJSON(json: any): NewsletterEmailDTO {
	return NewsletterEmailDTOFromJSONTyped(json, false);
}

export function NewsletterEmailDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): NewsletterEmailDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		subject: !exists(json, "subject") ? undefined : json["subject"],
		body: !exists(json, "body") ? undefined : json["body"],
		newsletterChannel: !exists(json, "newsletterChannel")
			? undefined
			: json["newsletterChannel"],
		publisherName: !exists(json, "publisherName")
			? undefined
			: json["publisherName"],
		initialRecipientsCount: !exists(json, "initialRecipientsCount")
			? undefined
			: json["initialRecipientsCount"],
		currentRecipientsCount: !exists(json, "currentRecipientsCount")
			? undefined
			: json["currentRecipientsCount"],
		priority: !exists(json, "priority")
			? undefined
			: EmailPriorityFromJSON(json["priority"]),
		expeditionEnabled: !exists(json, "expeditionEnabled")
			? undefined
			: json["expeditionEnabled"],
		recipients: !exists(json, "recipients")
			? undefined
			: json["recipients"] === null
			? null
			: (json["recipients"] as Array<any>).map(EmailRecipientDTOFromJSON),
		strategy: !exists(json, "strategy")
			? undefined
			: EmailSendStrategyFromJSON(json["strategy"]),
		recipientRole: !exists(json, "recipientRole")
			? undefined
			: RoleFromJSON(json["recipientRole"]),
		years: !exists(json, "years")
			? undefined
			: json["years"] === null
			? null
			: (json["years"] as Array<any>).map(StudentYearEnumFromJSON),
		faculties: !exists(json, "faculties")
			? undefined
			: json["faculties"] === null
			? null
			: (json["faculties"] as Array<any>).map(FacultyDTOFromJSON),
		departments: !exists(json, "departments")
			? undefined
			: json["departments"] === null
			? null
			: (json["departments"] as Array<any>).map(DepartmentDTOFromJSON),
		studyPrograms: !exists(json, "studyPrograms")
			? undefined
			: json["studyPrograms"] === null
			? null
			: (json["studyPrograms"] as Array<any>).map(StudyProgramDTOFromJSON),
	};
}

export function NewsletterEmailDTOToJSON(
	value?: NewsletterEmailDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		subject: value.subject,
		body: value.body,
		newsletterChannel: value.newsletterChannel,
		publisherName: value.publisherName,
		initialRecipientsCount: value.initialRecipientsCount,
		currentRecipientsCount: value.currentRecipientsCount,
		priority: EmailPriorityToJSON(value.priority),
		expeditionEnabled: value.expeditionEnabled,
		recipients:
			value.recipients === undefined
				? undefined
				: value.recipients === null
				? null
				: (value.recipients as Array<any>).map(EmailRecipientDTOToJSON),
		strategy: EmailSendStrategyToJSON(value.strategy),
		recipientRole: RoleToJSON(value.recipientRole),
		years:
			value.years === undefined
				? undefined
				: value.years === null
				? null
				: (value.years as Array<any>).map(StudentYearEnumToJSON),
		faculties:
			value.faculties === undefined
				? undefined
				: value.faculties === null
				? null
				: (value.faculties as Array<any>).map(FacultyDTOToJSON),
		departments:
			value.departments === undefined
				? undefined
				: value.departments === null
				? null
				: (value.departments as Array<any>).map(DepartmentDTOToJSON),
		studyPrograms:
			value.studyPrograms === undefined
				? undefined
				: value.studyPrograms === null
				? null
				: (value.studyPrograms as Array<any>).map(StudyProgramDTOToJSON),
	};
}
